<!-- loader -->
<div class="loader-full" id="loader-full">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</div>

<ngx-loading-bar></ngx-loading-bar>
<router-outlet></router-outlet>
<!-- <app-tap-to-top></app-tap-to-top> -->
<!-- <app-layout-box></app-layout-box> -->